import { z } from 'zod';
import { GREENHOUSE_STANDARD_LIST_ID } from './GreenhouseStandardList';
import {
  validateTextEn,
  EMPTY_FIELD_MESSAGE,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';

enum GH_STANDARD_MESSAGE {
  PRINCIPLE = 'กรุณาเลือกหลักการและมาตรฐานด้านการจัดการอย่างน้อย 1 ตัวเลือก',
  PRINCIPLE_OTHER = 'กรุณาระบุหลักการและมาตรฐานด้านการจัดการ',
  PRINCIPLE_OTHER_EN = 'กรุณาระบุหลักการและมาตรฐานด้านการจัดการเป็นภาษาอังกฤษ',
  REMARK_EN = 'กรุณาระบุหมายเหตุการปฎิบัติตามหลักการและมาตรฐานด้านการจัดการก๊าซเรือนกระจกหรือการเปลี่ยนแปลงสภาพภูมิอากาศเป็นภาษาอังกฤษ',
}

//FIXME: this is a workaround to check if the other field is interacted
export const otherFieldsInteracted = {
  nameTh: false,
  nameEn: false,
};

const PrincipleSchema = z
  .object({
    infoCategoryMasterDataId: z.number().optional(),
    nameTh: z.string().nullable().optional(),
    nameEn: z.string().nullable().optional(),
    checked: z.boolean().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    const { infoCategoryMasterDataId, checked = false, nameTh, nameEn } = data;
    if (
      checked &&
      infoCategoryMasterDataId === GREENHOUSE_STANDARD_LIST_ID.OTHER
    ) {
      if (otherFieldsInteracted.nameTh && nameTh !== undefined) {
        if (!nameTh) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: GH_STANDARD_MESSAGE.PRINCIPLE_OTHER,
            path: ['nameTh'],
          });
        } else if (!validateSpace(nameTh)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: EMPTY_FIELD_MESSAGE.SPACE_BAR,
            path: ['nameTh'],
          });
        }
      }

      if (otherFieldsInteracted.nameEn && nameEn !== undefined) {
        if (!nameEn) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: GH_STANDARD_MESSAGE.PRINCIPLE_OTHER,
            path: ['nameEn'],
          });
        } else if (!validateTextEn.test(nameEn)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: GH_STANDARD_MESSAGE.PRINCIPLE_OTHER_EN,
            path: ['nameEn'],
          });
        } else if (!validateSpace(nameEn)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: EMPTY_FIELD_MESSAGE.SPACE_BAR,
            path: ['nameEn'],
          });
        }
      }
    }
  });

export const GreenhouseStandardSchema = z.object({
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, GH_STANDARD_MESSAGE.REMARK_EN)
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  principles: z.record(z.string(), PrincipleSchema).refine(
    (principles) => {
      const values = Object.values(principles);
      return values.some((value) => value.checked === true);
    },
    { message: GH_STANDARD_MESSAGE.PRINCIPLE }
  ),
});
